
import React from 'react'
import { Tab, Nav, Container, Col, Row } from "react-bootstrap";
import FeatureTabPenLayout from './Components/FeatureTabPenLayout'
import FeatureImage from './Components/FeatureImages'
import Feature from './style'
import featureSectionData from '~data/project/features'
import FeatureWidgetsBlock from './Components/FeatureWidgetsBlock'
export default function FeatureSection() {
  return (
    <Feature background="#0452cc">
      <Container className="container">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="first"
        >
          <Feature.Tab>
            <Row className="justify-content-center">
              <Col className="col-xl-7 col-lg-8 col-md-10">
                <Nav className="nav nav-tabs" id="myTab" role="tablist">
                  <Nav.Link
                    eventKey="first"
                    className="nav-link"
                    style={{
                      width: "240px",
                      justifyContent: "center"
                    }}  
                  >Document Collaboration
                  </Nav.Link>
                  <Nav.Link
                    eventKey="second"
                    className="nav-link"
                    style={{
                      width: "240px",
                      justifyContent: "center"
                    }}
                  >Document Workflow
                  </Nav.Link>
                  <Nav.Link
                    eventKey="third"
                    className="nav-link"
                    style={{
                      width: "240px",
                      justifyContent: "center"
                    }}
                  >Document AI
                  </Nav.Link>
                </Nav>
              </Col>
            </Row>
            <Tab.Content className="tab-content">
              <Tab.Pane eventKey="first">
                <FeatureTabPenLayout
                  imageBlock={<FeatureImage mainImage="https://docpile-assets.s3.us-east-2.amazonaws.com/images/document-sending.gif" />}
                  contentBlock={<FeatureWidgetsBlock widgetData={featureSectionData.tabWidget1} />}
                  contentBlockTitle={featureSectionData.featureTabTitle1}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <FeatureTabPenLayout
                  imageBlock={<FeatureImage mainImage="https://docpile-assets.s3.us-east-2.amazonaws.com/images/document-invite.gif" />}
                  contentBlock={<FeatureWidgetsBlock widgetData={featureSectionData.tabWidget2} />}
                  contentBlockTitle={featureSectionData.featureTabTitle2}
                />
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                <FeatureTabPenLayout
                  imageBlock={<FeatureImage mainImage="https://docpile-assets.s3.us-east-2.amazonaws.com/images/document-scan.gif" />}
                  contentBlock={<FeatureWidgetsBlock widgetData={featureSectionData.tabWidget3} />}
                  contentBlockTitle={featureSectionData.featureTabTitle3}
                />
              </Tab.Pane>
            </Tab.Content>
          </Feature.Tab>
        </Tab.Container>
      </Container>
    </Feature>
  )
}